<template>
  <InputGroup :class="$style.inputGroup" :style="{ cursor: disabled ? 'initial' : 'pointer' }">
    <InputGroupAddon :style="{ backgroundColor: disabled ? 'var(--vd-color-surface-200)' : 'white' }">
      <VdIcon :name="getIconName(selectedPriceType)" color="var(--vd-color-blue-gray-300)"></VdIcon>
    </InputGroupAddon>
    <div
      v-if="isSaved && selectedPriceType === 'IN_GAME_CURRENCY' && formState.selectedInGamePrice"
      :class="[$style.rewardItemsWrapper, disabled ? $style.inputDisabled : '']"
    >
      <PriceItemWithQuantity
        :store-item="formState.selectedInGamePrice"
        :price-amount="formState.selectedIosInGamePriceAmount"
        :platform="Platform.Ios"
      />
      <PriceItemWithQuantity
        :store-item="formState.selectedInGamePrice"
        :price-amount="formState.selectedAndroidInGamePriceAmount"
        :platform="Platform.Android"
      />
    </div>
    <div
      v-if="isSaved && selectedPriceType === 'IAP'"
      :class="[$style.rewardItemsWrapper, disabled ? $style.inputDisabled : '']"
    >
      <PriceByPlatform :price-amount="formState.iosIapAmount" :platform="Platform.Ios" />
      <PriceByPlatform :price-amount="formState.androidIapAmount" :platform="Platform.Android" />
    </div>
    <div
      v-if="isSaved && selectedPriceType === 'RV'"
      :class="[$style.rewardItemsWrapper, disabled ? $style.inputDisabled : '']"
    >
      <PriceByPlatform :price-amount="formState.selectedIosRVAmount" :platform="Platform.Ios" />
      <PriceByPlatform :price-amount="formState.selectedAndroidRVAmount" :platform="Platform.Android" />
    </div>
    <div
      v-if="isSaved && selectedPriceType === 'FREE'"
      :class="[$style.rewardItemsWrapper, disabled ? $style.inputDisabled : '']"
    >
      <span>Free</span>
    </div>
    <div
      v-else-if="!isSaved"
      :class="[$style.inputText, 'p-inputtext', 'p-component', disabled ? $style.inputDisabled : '']"
    >
      <span :class="$style.placeHolder">Price</span>
    </div>
    <InputGroupAddon :style="{ backgroundColor: disabled ? 'var(--vd-color-surface-200)' : 'white' }">
      <VdIcon store="fa" name="chevron-down" size="large" color="var(--vd-color-text-light-2)"></VdIcon>
    </InputGroupAddon>
  </InputGroup>
</template>

<script setup lang="ts">
import { Platform } from "@/graphql";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";

import VdIcon from "@/components/VdIcon/VdIcon.vue";
import PriceByPlatform from "../PriceByPlatform.vue";
import PriceItemWithQuantity from "../PriceItemWithQuantity.vue";

defineProps({
  selectedPriceType: {
    type: String,
    required: true,
  },
  isSaved: {
    type: Boolean,
    required: true,
  },
  formState: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const getIconName = (name: string) => {
  switch (name) {
    case "IAP":
      return "money-bill";
    case "IN_GAME_CURRENCY":
    case "FREE":
      return "box";
    case "RV":
      return "clapperboard-play";
    default:
      return "";
  }
};
</script>

<style module lang="scss">
.inputGroup {
  height: 32px;
}

.placeHolder {
  color: var(--vd-color-text-light-2);
}

.inputText {
  border-right: none;
  border-left: none;
  border-top: 1px solid #bcbec1;
  border-bottom: 1px solid #bcbec1;
  opacity: 1;
  font-size: 12px;
  color: var(--vd-color-text-dark);
  align-self: center;
  padding: 0.55rem 0;
  overflow-x: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  height: 32px;
}
.rewardItemsWrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-right: none;
  border-left: none;
  border-top: 1px solid #bcbec1;
  border-bottom: 1px solid #bcbec1;
  height: 32px;
  font-weight: lighter;
  font-size: 12px;
  font-weight: 400;
}

.inputDisabled {
  background-color: var(--vd-color-surface-200);
}
</style>
